import { render, staticRenderFns } from "./WestNileVirus.vue?vue&type=template&id=244b3423"
import script from "./WestNileVirus.vue?vue&type=script&lang=js"
export * from "./WestNileVirus.vue?vue&type=script&lang=js"
import style0 from "./WestNileVirus.vue?vue&type=style&index=0&id=244b3423&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports